import { render } from "./loginUser.vue?vue&type=template&id=2808d7ab"
import script from "./loginUser.vue?vue&type=script&lang=js"
export * from "./loginUser.vue?vue&type=script&lang=js"

import "./loginUser.vue?vue&type=style&index=0&id=2808d7ab&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__